'use client';
import { AddShoppingCart } from '@mui/icons-material';
import { Alert, Chip } from '@mui/material';
import CurriculumTable from '@/components/curriculum/curriculum-table';
import { useCourses } from '@/providers';

export default function CurriculumTab() {
  const { selectedCourse, isLoading, courseStatus } = useCourses();

  if (!selectedCourse || isLoading) return null;

  return (
    <>
      {!courseStatus?.hasMembership && (
        <Alert severity="info" sx={{ mb: 2 }} icon={<AddShoppingCart />}>
          Teste Kapitel mit{' '}
          <Chip label="kostenlos" size="small" variant="outlined" color="success" sx={{ mx: 1 }} />{' '}
          ohne Kauf. Um alle Kapitel nutzen zu können, kaufe den Kurs.
        </Alert>
      )}
      <CurriculumTable
        course={selectedCourse}
        hasMembership={courseStatus?.hasMembership ?? false}
      />
    </>
  );
}
